import { Injectable, inject } from '@angular/core';
import { FilesState } from '@shared';
import { GetFilesStateResult } from './get-files-state.result';

/**
 * Use case for accessing file upload state.
 * Provides controlled access to FilesState for the presentation layer.
 *
 * This follows Clean Architecture principles by:
 * - Preventing direct state injection in presentation layer
 * - Exposing only necessary state signals
 * - Maintaining clear separation of concerns
 */
@Injectable({ providedIn: 'root' })
export class GetFilesStateUseCase {
  private readonly _state = inject(FilesState);

  /**
   * Returns read-only access to file upload state signals.
   */
  public execute(): GetFilesStateResult {
    return {
      uploadingFiles: this._state.uploadingFiles,
      uploadedFiles: this._state.uploadedFiles,
      uploadErrors: this._state.uploadErrors,
      overallProgress: this._state.overallProgress,
    };
  }
}
